module.exports = __webpack_public_path__ + "img/header-weddingRingsStarrySky@2x.f36c9c7.webp";